import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { NONE } from '../../scripts/models/request-status';

import { SetInitDataPayload, SuperAdminState } from './superAdminTypes';

const initialState: SuperAdminState = {
  urls: [],
  hostOptions: null,
  saveHostOptionsStatus: NONE
};

const superAdminSlice = createSlice({
  name: 'superAdmin',
  initialState,
  reducers: {
    setInitData(state: SuperAdminState, action: PayloadAction<SetInitDataPayload>) {
      const { urls, hostOptions } = action.payload;

      state.urls = urls;
      state.hostOptions = hostOptions;
    },
    setUrls(state: SuperAdminState, action: PayloadAction<string[]>) {
      state.urls = action.payload;
    },
    setHostOptionsStatus(state: SuperAdminState, action: PayloadAction<string>) {
      state.saveHostOptionsStatus = action.payload;
    },
    setHostOptions(state: SuperAdminState, action: PayloadAction<string>) {
      state.hostOptions = action.payload;
    }
  }
});

export const superAdminReducer = superAdminSlice.reducer;

export const superAdminActions = superAdminSlice.actions;

export const {
  setInitData,
  setUrls,
  setHostOptionsStatus,
  setHostOptions,
} = superAdminActions;
